import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GETCMLIST } from 'src/app/components/Shared/Model/GETCMLIST'
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { interval } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type:any
}
@Component({
  selector: 'app-cmtopmsbooking',
  templateUrl: './cmtopmsbooking.component.html',
  styleUrls: ['./cmtopmsbooking.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class CmtopmsbookingComponent implements OnInit {
  apiresult: any;
  hotellistChannel: GETCMLIST[];
  hotellistproperty: any;
  today = new Date();
  CHResponseDisplay: boolean;
  hotelSearchDataStatus: any;
  productType: any;
  heartBeatData: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  ValSearchDownload: string;
  filterProperty: any;
  XMLName: string;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) {

  }
  lstgetcmlist1: any = [] = [];
  dropdownSettings = {};
  PGF: any = "0";
  PGT: any = "50";
  totalcount: any = 0;
  pageSize = 50;
  selectedChannel: any;
  defaultData: any = [] = [];
  public status: string;
  public header: string;
  rateCode: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  public LOGS: any;
  lstgetcmlist: any[];
  lstTCTOPMSCopy: any = [] = [];
  lstTCTOPMS: any = [] = [];
  // dataSource: any = [];
  hotellistCopy: any = [] = [];
  hotellist: any = [] = [];
  allproperty: any[];
  selected: string;
  selectedItems: string;
  Val: string;
  //status:any=[]=[];
  display: Boolean = false;
  displayedColumns: string[] = ['Status', 'CRS#', 'PMS#', 'Arrival', 'Departure', 'Guest', 'Created date', 'Send date', 'Response date', 'reqxml', 'reqackxml','resxml','resackxml'] // 'RequestXML', 'ResponseXML'];  
  Userid: any = [];
    /* Search Field */
    dropdownSettingsDept: IDropdownSettings = {};
    selectedDeptItems: any;
    dropdownDeptData: any;
    currentDateStore: any;
    storeHeartBeatValue: any;
    blinkOfflineHotel: boolean;
    todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  searchBarFilter: boolean = false;

  hideSearchFilter(){
    this.ValSearchDownload = '';
    this.searchBarFilter = false
  }

  ngOnInit() {

    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
      this.callIDSUsersProperties();
      this.dropdownSettingsDept = {
        idField: 'pmscode',
        textField: 'pmsname',
        allowSearchFilter: true,
        singleSelection: true,
        enableCheckAll: false,
        closeDropDownOnSelection:true,
        itemsShowLimit: 7,
        noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText:"Search Hotel Code / Name"
      };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getchannelFXFN()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          // if (data.length < 1) {
          //   this.toastr.error('Property is not activated with Channel manager');
          // }
          //Remove duplicate data
          this.apiresult = data;
          console.log('Property 113 = ', data)

          this.hotellist = this.apiresult.filter((obj, pos, arr) => {
            return arr
              .map(mapObj => (mapObj.pmsname))
              .indexOf(obj.pmsname) == pos;
          });
          this.hotellistChannel = this.lstgetcmlist;
          this.dropdownDeptData = this.hotellist;
          this.hotellistproperty = this.hotellist;
          this.isProgressing = false;
        });

  }

  changePropertySearch() {
  if(this.selectedDeptItems){
    this.searchBarFilter = false
    this.ValSearchDownload = '';
    if(this.selectedDeptItems.length > 0){
      console.log('if condition')
      this.totalcount = 0
      this.Pmscodevalue = this.selectedDeptItems[0].pmscode
      console.log('pms code value = ',this.Pmscodevalue)
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false

      var result=this.apiresult.filter((obj: { pmscode: MatSelectChange; })=> obj.pmscode == this.Pmscodevalue);
      console.log('filter record = ',result);
      this.lstgetcmlist = result;
      this.selectedChannel = this.lstgetcmlist[0].cmcode;
      // For Online Status
    this.apiCallIdsService
    .readHotelSearch(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHotelSearch =',data)
      this.hotelSearchDataStatus = data[0].recordstatus
      this.productType = data[0].producttype
    });
      this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =',data[0])
        this.heartBeatData = data[0].heartBeat

        
// For blinking the record
const today = new Date()
console.log('Today Date = ',today);
this.currentDateStore = today.toLocaleTimeString('it-IT')
console.log('Today Date = ',this.currentDateStore);
this.storeHeartBeatValue = this.GetParseonlyDateTimeBlink(this.heartBeatData)
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[1], 0);
var endDate = new Date(0, 0, 0, end[0], end[1], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
// console.log('minutes difference',minutes)
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
}

      });
      interval(2000 * 60).subscribe(() => {
        this.heartbeatFunction();
      });
    }else{
      console.log('Else condition zero')
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
    }
  }else{
    console.log('Property Not Selected')
  }
  }

  
  GetParseonlyDateTimeBlink(d:any) {
    console.log('GetParseonlyDateTime call',d.substring(12))
    return (d.substring(12));
  }
  heartbeatFunction(){
    this.apiCallIdsService
    .readHeartbeat(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHeartbeat =',data[0])
      this.heartBeatData = data[0].heartBeat
    });
  }

  changeChannel(data) {
    console.log("selected --->" + data);
    // this.Pmscodevalue = data;
    this.isProgressing = true;
    if (data == 'All') {
      this.lstgetcmlist = this.hotellistChannel
      this.hotellist = this.hotellistproperty
      this.selectedChannel = this.lstgetcmlist[0].cmcode
      this.selectedItems = this.hotellist[0].pmscode
    } else {
      var result = this.apiresult.filter(obj => obj.cmcode == data);
      console.log(result);
      this.hotellist = result;
      this.selectedItems = this.hotellist[0].pmscode;
      console.log(this.selectedItems)
    }
    this.Val = null;
    // this.selectedChannel = this.filteredrecord[0].cmcode;
    this.isProgressing = false;
  }

  Search(event:any) {
    console.log('event= ', event)
    this.hotellist = this.hotellistproperty.filter((res: { pmsname: { toString: () => string; }; pmscode: { toString: () => string; }}) => {
      return res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
      if(event == ''){
        this.Val = '';
        this.callIDSUsersProperties();
      }
  }

  SearchChannel(event) {
    console.log('event= ', event)
    if (this.Val != '')
      this.lstgetcmlist = this.hotellistChannel.filter(res => {
        return res.cmname.toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
      });
  }

  GetCommonMethodForLog() {
    this.searchBarFilter = true
    this.PGF = 0;
    this.PGT = 50;
    this.GetTCTOPMS();
  
  }

  GetTCTOPMS() {
    this.isProgressing = true;
    this.LOGS = "PMSTOTC_Bookings";
    var Userid = undefined
    var PMS_NUB = undefined
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');

    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');

    }
    else {
      this.apiCallIdsService.getTCTOPMS(this.Pmscodevalue, this.LOGS, this.selectedChannel, this.selectedDate, this.selectedTOODate, "undefined", this.PGF, this.PGT, "undefined")
      .subscribe(
        data => {
          console.log('Data Length = ',data.length);
          if(data.length > 0){
            this.errorMsgSubscription = false
            this.displayContent = true
            this.filterProperty = data
            this.idsProductList=data;
            this.totalcount = data[0].totalCount;
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing = false;
        }else{
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
        }
        });
    }

    
  }

  SearchDownload(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { gstnam: { toString: () => string; }; pmS_NUB: { toString: () => string; }; tC_NUB: { toString: () => string; } }) => {
      return res.gstnam.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase()) || res.pmS_NUB.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase()) || res.tC_NUB.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase());
    });
    if (event == '') {
      console.log('if search')
      this.ValSearchDownload = '';
    }
  }

  pageEvent(e:any) {
    console.log('pageEvent = ', e)
    // console.log('pageIndex = ', e.pageIndex)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetTCTOPMS();
  }

  GetParseonlyDateTime(d) {
    if (d == "") {
      return "";
    }
    return (d.substring(0, 2)).trim() + "-" + (d.substring(2, 6)).trim() + "-" + (d.substring(6, 11)).trim() + " " + (d.substring(12, 17)).trim();

  }
  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
  showXml(xmltype, token) {
    this.LoadXML(xmltype, token);
  }

  LoadXML(xmltype, token) {
    this.isProgressing = true;
    this.apiCallIdsService.getPMSbookingXML(xmltype, token)
      .subscribe(data => {

        if (data.length < 1) {
          this.toastr.error('No data to load');
          this.isProgressing = false;
        }

        //this.defaultData = data[0].xmlData;
        //console.log(this.defaultData);
        const xml = beautify(data[0].xmlData);

        console.log(xml);
        this.defaultData = xml;
        this.display = true;
        this.isProgressing = false;
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }

  showResponseXml(textXML,token) {
       const xml = beautify(token);
      this.XMLName = textXML
      console.log(xml);
      this.defaultData = xml;
      this.display = true;
      this.isProgressing = false;
  }
  closeResponseXml() {
    this.CHResponseDisplay = false;
  }
  LoadResponseXML(xmltype, token) {
    this.isProgressing = true;
    this.apiCallIdsService.getPMSbookingXML(xmltype, token)
      .subscribe(data => {

        if (data.length < 1) {
          this.toastr.error('No data to load');
          this.isProgressing = false;
        }
        const xml = beautify(data[0].xmlData);

        console.log(xml);
        this.defaultData = xml;
        this.display = true;
        this.isProgressing = false;
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }
}
